import { IMAGES } from '../constants/theme';
import { HashLink } from 'react-router-hash-link';

const PageTitle = ({parentTitle, activePage, to=""}) => {
    return (
        <>
            <div className="dz-bnr-inr style-1 text-center" style={{backgroundImage: "url("+IMAGES.BgBanner2 +")"}}>
                <div className="container">
                    <div className="dz-bnr-inr-entry">
                        <h1>{activePage}</h1>
                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><HashLink to={`/${to}`}>{parentTitle}</HashLink></li>{" "}
                                <li className="breadcrumb-item active" aria-current="page">{activePage}</li>
                            </ul>
                        </nav>
                        
                    </div>
                </div>
            </div>
          
        </>
    );
};

export default PageTitle;